import cx from "classnames";
import React, { memo } from "react";

interface IProps {
  clear: boolean;
  onClick: () => void;
  review: boolean;
}

const REMOVE_MESSAGE = "Are you sure you want to remove this field?";
const CLEAR_MESSAGE = "Are you sure you want to clear this field?";

const RemoveButtonComponent = ({ clear, onClick, review }: IProps) => (
  <a
    className="text-danger"
    href="#"
    onClick={e => {
      e.preventDefault();
      if (review) {
        return;
      }
      if (window.confirm(clear ? CLEAR_MESSAGE : REMOVE_MESSAGE)) {
        onClick();
      }
    }}
    title="Remove"
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.00008 12.8332C10.2217 12.8332 12.8334 10.2215 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.2215 3.77842 12.8332 7.00008 12.8332Z" fill="white" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.33342 4.6665L7.00008 6.99984L9.33342 4.6665ZM7.00008 6.99984L4.66675 9.33317L7.00008 6.99984ZM7.00008 6.99984L4.66675 4.6665L7.00008 6.99984ZM7.00008 6.99984L9.33342 9.33317L7.00008 6.99984Z" fill="#616161"/>
      <path d="M7.00008 6.99984L9.33342 9.33317M9.33342 4.6665L7.00008 6.99984L9.33342 4.6665ZM7.00008 6.99984L4.66675 9.33317L7.00008 6.99984ZM7.00008 6.99984L4.66675 4.6665L7.00008 6.99984Z" stroke="#616161" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </a>
);
RemoveButtonComponent.displayName = "RemoveButton";
export const RemoveButton = memo(RemoveButtonComponent);
